import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { LeadActivity, LeadActivityCreate, LeadActivityFilter } from '../data/leadActivity';

export function createLeadActivityService(client: AxiosInstance) {
  return createCrudService<LeadActivity, LeadActivityCreate, LeadActivityFilter>(
    client,
    '/crm/LeadActivity',
    'id',
  );
}

export type LeadActivityService = CrudService<LeadActivity, LeadActivityCreate, LeadActivityFilter>;
